import { render, staticRenderFns } from "./SubStoryList.vue?vue&type=template&id=b6b8f2ee&scoped=true"
import script from "./SubStoryList.vue?vue&type=script&lang=js"
export * from "./SubStoryList.vue?vue&type=script&lang=js"
import style0 from "./SubStoryList.vue?vue&type=style&index=0&id=b6b8f2ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b8f2ee",
  null
  
)

export default component.exports